import React, { Component } from 'react';
import { Dropdown } from 'semantic-ui-react';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';
import Errordialog from '../../errordialog';

class Setexecutive extends Component {

  state = {
    executives: [],
    selectedExecutives: []
  }

  componentDidMount() {
    this.setAllExecutives();
    this.setSelectedExecutives();
  }

  setAllExecutives() {
    let context = this;
    var executive = [];
    this.props.executive.map((y) => {
      executive.push({key: y.name, text: y.name, value: y.id});
    });
    this.setState({
      executives: executive
    })
  }

  setSelectedExecutives() {
    let context = this;
    var selected = [];
    this.props.data.map((z) => {
      if (z.type == 'executive') {
        if (z.account == context.props.id) {
          context.props.executive.map((y) => {
            let b= true;
            for (var i = 0; i < selected.length; i++) {
              if (selected[i].value == y.id) {
                b = false;
                break;
              }
            }
            if (z.bank_name == y.id && b) {
              selected.push(z.bank_name);
            }
          });
        }
      }
    });
    context.setState({
      selectedExecutives: selected
    });
  }

  category = (f, { value }) => {
    if (!this.props.menuPermission.edit) {
      alert("Access is Denied!!!");
      return;
    }
    this.check(value, this.state.selectedExecutives);
    this.setState({ selectedExecutives: value })
  }

  add(val) {
    let context = this;
    context.setState({
      load: true,
      message: 'Adding Executive'
    })
    let data = {'id': this.props.id, 'executive': val};
    $.ajax({
      type: 'POST',
      data: data,
      url: Server() + 'bankdetails/addexecutive.php',
      success: function(data)
      {
        if (data == 1) {
          context.setState({
            load: false,
          })
        }
        else {
          context.setState({ load: false, errorDialog: true, errormessage: 'Failed to add item!!!' })
        }
      },
      error: function(e)
      {
        context.setState({
          load: false,
        })
      }
    });
  }

  remove(val) {
    let context = this;
    context.setState({
      load: true,
      message: 'Removing Executive'
    })
    let data = {'id': this.props.id, 'executive': val};
    $.ajax({
      type: 'POST',
      data: data,
      url: Server() + 'bankdetails/removeexecutive.php',
      success: function(data)
      {
        if (data == 1) {
          context.setState({
            load: false,
          })
        }
        else {
          context.setState({ load: false, errorDialog: true, errormessage: 'Failed to remove item!!!' })
        }
      },
      error: function(e)
      {
        context.setState({
          load: false,
        })
      }
    });
  }

  check(value, oldValue) {
    let length = value.length;
    if (length > oldValue.length) {
      let x = (value[value.length - 1]);
      this.add(x);
    } else if (length < oldValue.length) {
      let array1 = oldValue.filter(val => !value.includes(val));
      this.remove(array1[0]);
    }
  }

  closeErrorDialog() {
    this.setState({ errorDialog: false });
  }

  render() {
    let { executives, selectedExecutives, load, message } = this.state;
    return (
      <div>
        <Dropdown placeholder='Executive' style={{ borderColor: '#5A9CBB', fontSize: 11 }}
          multiple fluid search selection onChange={this.category}
          options={executives} value={selectedExecutives} />
        <Loading load={load} message={message} />
        <Errordialog load={this.state.errorDialog} message={this.state.errormessage} close={this.closeErrorDialog.bind(this)} />
      </div>
    );
  }
}

export default Setexecutive;
